import React from "react";

const Team = () => {
  return (
    <>
      <section className="tw-py-20 lg:tw-py-28 tw-bg-[#F5F4FF]/30 tw-border-t tw-border-solid tw-border-slate-100" id="team">
        <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
          
          {/* Header */}
          <div className="tw-text-center tw-max-w-3xl tw-mx-auto tw-mb-16">
            <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-uppercase tw-tracking-widest tw-mb-4 tw-bg-indigo-50 tw-px-4 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-indigo-100">
              <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-inline-block" />
              Company Culture
            </span>
            <h2 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight tw-mb-6">
              Company Culture
            </h2>
            <p className="tw-text-base sm:tw-text-lg tw-text-slate-600 tw-leading-relaxed tw-m-0">
              BeyondLeadz offers a fantastic company culture that fosters a
              positive work environment, where employees feel valued,
              respected, and motivated to contribute to the team's success. We
              have a young team and fun environment where creativity and
              innovation thrive, resulting in a dynamic workplace where fresh
              ideas are encouraged and celebrated.
            </p>
          </div>

          {/* Subheader Intro */}
          <div className="tw-max-w-3xl tw-mx-auto tw-text-center tw-mb-12">
            <p className="tw-text-sm sm:tw-text-base tw-font-semibold tw-text-[#5D44FF] tw-italic tw-m-0">
              Here are some strategies we use to attract talented individuals to our team:
            </p>
          </div>

          {/* Strategies Grid */}
          <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-8 tw-mb-16">
            
            {/* Strategy 1 */}
            <div className="tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.02] tw-transition-all tw-duration-300 tw-flex tw-flex-col">
              <div className="tw-w-10 tw-h-10 tw-rounded-xl tw-bg-indigo-50 tw-text-[#5D44FF] tw-font-extrabold tw-flex tw-items-center tw-justify-center tw-mb-6 tw-text-sm tw-shadow-inner tw-flex-shrink-0">
                01
              </div>
              <h3 className="tw-text-lg tw-font-bold tw-text-slate-800 tw-mb-3">
                Create a strong company culture:
              </h3>
              <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0 tw-flex-grow">
                A positive and inclusive company culture is essential for attracting top
                talent. We prioritize creating a work environment that is
                welcoming, supportive, and encourages collaboration. We also
                provide opportunities for professional growth and development, as
                well as a healthy work-life balance.
              </p>
            </div>

            {/* Strategy 2 */}
            <div className="tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.02] tw-transition-all tw-duration-300 tw-flex tw-flex-col">
              <div className="tw-w-10 tw-h-10 tw-rounded-xl tw-bg-indigo-50 tw-text-[#5D44FF] tw-font-extrabold tw-flex tw-items-center tw-justify-center tw-mb-6 tw-text-sm tw-shadow-inner tw-flex-shrink-0">
                02
              </div>
              <h3 className="tw-text-lg tw-font-bold tw-text-slate-800 tw-mb-3">
                Offer competitive compensation and benefits:
              </h3>
              <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0 tw-flex-grow">
                Offering competitive salaries and benefits packages is important
                for attracting talented individuals. We ensure that our
                compensation packages are competitive with other companies in our
                industry and include benefits such as health insurance, retirement
                plans, and paid time off.
              </p>
            </div>

            {/* Strategy 3 */}
            <div className="tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.02] tw-transition-all tw-duration-300 tw-flex tw-flex-col">
              <div className="tw-w-10 tw-h-10 tw-rounded-xl tw-bg-indigo-50 tw-text-[#5D44FF] tw-font-extrabold tw-flex tw-items-center tw-justify-center tw-mb-6 tw-text-sm tw-shadow-inner tw-flex-shrink-0">
                03
              </div>
              <h3 className="tw-text-lg tw-font-bold tw-text-slate-800 tw-mb-3">
                Emphasize our mission and values:
              </h3>
              <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0 tw-flex-grow">
                Our mission and values are an integral part of our company, and we make sure
                to emphasize these to potential candidates. We want individuals
                who are aligned with our mission and values, and who are
                passionate about making a positive impact in the world.
              </p>
            </div>

            {/* Strategy 4 */}
            <div className="tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.02] tw-transition-all tw-duration-300 tw-flex tw-flex-col">
              <div className="tw-w-10 tw-h-10 tw-rounded-xl tw-bg-indigo-50 tw-text-[#5D44FF] tw-font-extrabold tw-flex tw-items-center tw-justify-center tw-mb-6 tw-text-sm tw-shadow-inner tw-flex-shrink-0">
                04
              </div>
              <h3 className="tw-text-lg tw-font-bold tw-text-slate-800 tw-mb-3">
                Utilize social media and other platforms:
              </h3>
              <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0 tw-flex-grow">
                We use social media and other platforms to reach out to potential
                candidates and showcase our company culture and values. We also
                participate in industry events and conferences to connect with
                potential hires and build relationships.
              </p>
            </div>

            {/* Strategy 5 */}
            <div className="tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.02] tw-transition-all tw-duration-300 tw-flex tw-flex-col md:tw-col-span-1 lg:tw-col-span-1">
              <div className="tw-w-10 tw-h-10 tw-rounded-xl tw-bg-indigo-50 tw-text-[#5D44FF] tw-font-extrabold tw-flex tw-items-center tw-justify-center tw-mb-6 tw-text-sm tw-shadow-inner tw-flex-shrink-0">
                05
              </div>
              <h3 className="tw-text-lg tw-font-bold tw-text-slate-800 tw-mb-3">
                Provide opportunities for remote work:
              </h3>
              <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0 tw-flex-grow">
                The ability to work remotely has become increasingly important in
                today's workforce. We offer remote work opportunities to attract
                talented individuals from all over the world, and to provide our
                employees with a flexible work-life balance.
              </p>
            </div>

          </div>

          {/* Highlights Callout Box */}
          <div className="tw-max-w-4xl tw-mx-auto tw-mt-12 tw-bg-indigo-50/50 tw-border tw-border-solid tw-border-indigo-100/50 tw-rounded-3xl tw-p-8 lg:tw-p-10 tw-text-center tw-relative tw-overflow-hidden">
            {/* Decorative background blur/orb */}
            <div className="tw-absolute -tw-right-10 -tw-top-10 tw-w-40 tw-h-40 tw-bg-indigo-200/20 tw-rounded-full tw-blur-2xl tw-pointer-events-none" />
            <div className="tw-absolute -tw-left-10 -tw-bottom-10 tw-w-40 tw-h-40 tw-bg-indigo-300/20 tw-rounded-full tw-blur-2xl tw-pointer-events-none" />
            
            <p className="tw-text-base sm:tw-text-lg tw-text-slate-700 tw-leading-relaxed tw-font-medium tw-m-0 tw-relative tw-z-10">
              Attracting top talent is an ongoing process, and we are always
              looking for new ways to improve our recruitment strategies. By
              prioritizing our company culture, offering competitive
              compensation and benefits, emphasizing our mission and values,
              utilizing social media and other platforms, and providing
              opportunities for remote work, we are able to attract talented
              individuals to our team and continue to grow our business.
            </p>
          </div>

        </div>
      </section>

      {/* <div className="choose jarallax">
        <div className="w3-agile-testimonial">
          <div className="container">
            <div className="w3-agileits-choose">
              <div className="col-md-12 choose-grid">        
                <h3 className="title-style mb-2" align="center">Current Openings</h3>
                <div align="center"><p>You join a young, bright and talented team that servives to succeed.</p></div>
                
                <div className="top-choose-info">
                
                  <div className="choose-info-top">
                    <div className="choose-left-grid col-sm-6">
                      <div className="choose-info-grid">
                          <p>Senior Front End Developer</p>
                          <div className="small">Experience 4-8 years | Full Time | Posted 3 hrs ago</div>
                      </div>
                    </div>
                    <div className="choose-right-grid col-sm-6">
                      <div className="choose-info-grid ">
                          <p><div className="mt-md-5 mt-4 mb-lg-0 mb-4"><a className="btn btn-style" href="apply.html">Apply</a></div></p>
                      </div>
                    </div>
                    <div className="clearfix"> </div>
                  </div>
                  
                  <div className="choose-info-top">
                    <div className="choose-left-grid col-sm-6">
                      <div className="choose-info-grid ">
                          <p>Senior UI Developer</p>
                          <div className="small">Experience 4-8 years | Full Time | Posted 3 hrs ago</div>
                      </div>
                    </div>
                    <div className="choose-right-grid col-sm-6">
                      <div className="choose-info-grid ">
                          <p><div className="mt-md-5 mt-4 mb-lg-0 mb-4"><a className="btn btn-style" href="apply.html">Apply</a></div></p>
                      </div>
                    </div>
                    <div className="clearfix"> </div>
                  </div>
                  <div className="choose-info-top">
                    <div className="choose-left-grid col-sm-6">
                      <div className="choose-info-grid ">
                          <p>Senior UX Developer</p>
                          <div className="small">Experience 4-8 years | Full Time | Posted 3 hrs ago</div>
                        </div>
                    </div>
                    <div className="choose-right-grid col-sm-6">
                      <div className="choose-info-grid ">
                          <p><div className="mt-md-5 mt-4 mb-lg-0 mb-4"><a className="btn btn-style" href="apply.html">Apply</a></div></p>
                      </div>
                    </div>
                    <div className="clearfix"> </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default Team;
